import ItemInfo from '../ItemInfo/ItemInfo';

const Approach = ({ id }) => {
	const ident = id;

	return (
		<div id={ident} className="main__approach approach-main">
			<div className="approach-main__body">
				<h2 className="approach-main__title _title">Для кого подходит?</h2>
				<div className="approach-main__items">
					<ItemInfo
						image='assets/images/mainPage/approach/approach_1.png'
						title='Кто не хочет платить за сами лекции'
						description='А только за проверку знаний (ведь все есть в интернете)'
						isHasButton={false}
					/>
					<ItemInfo
						image='assets/images/mainPage/approach/approach_2.png'
						title='Кому сложно учиться самостоятельно'
						description='У вас всегда будет с кем обсудить непонятные темы один на один'
						isHasButton={false}
					/>
					<ItemInfo
						image='assets/images/mainPage/approach/approach_3.png'
						title='Кому важно совмещать учебу с работой'
						description='Вы выбираете свой комфортный темп обучения '
						isHasButton={false}
					/>
				</div>
			</div>
		</div>
	)

}

export default Approach;